import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { format } from 'date-fns';
import * as S from '../styles';
import { FiCalendar, FiCheckCircle, FiList, FiX } from 'react-icons/fi';
import { ApiEvento } from '../../../services/FiltrosApi/eventoApi';
import { descricaoParaTexto } from '../../../services/descricaoEventoUtil';

// -----------------------------
export default function TarefasDia({ aberto, onFechar, eventosBrutos, eventoInicial }) {
  const { SalvarTarefasEvento } = ApiEvento();

  const dataAtual = new Date();
  const anoNotas = dataAtual.getFullYear();
  const mesNotas = dataAtual.getMonth();
  const diaAtualNumero = dataAtual.getDate();
  const quantidadeDiasNotas = new Date(anoNotas, mesNotas + 1, 0).getDate();
  const hojeFormatado = format(dataAtual, 'yyyy-MM-dd');

  const [diaNotasSelecionado, setDiaNotasSelecionado] = useState(format(dataAtual, 'yyyy-MM-dd'));
  const [mostrarTodasTarefas, setMostrarTodasTarefas] = useState(false);
  const [mostrarConcluidas, setMostrarConcluidas] = useState(false);
  const [linhaTexto, setLinhaTexto] = useState('');
  const [eventosDaPlaca, setEventosDaPlaca] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState(null);
  const [eventosSnapshot, setEventosSnapshot] = useState([]);
  const [salvandoTarefa, setSalvandoTarefa] = useState(false);
  const [mostrarSeletorData, setMostrarSeletorData] = useState(false);
  const [dataVencimentoManual, setDataVencimentoManual] = useState('');

  const inputRef = useRef(null);
  const medidorRef = useRef(null);
  const [larguraTexto, setLarguraTexto] = useState(0);

  // Reseta o formulário sempre que o modal é reaberto
  useEffect(() => {
    if (!aberto) return;

    setDiaNotasSelecionado(format(new Date(), 'yyyy-MM-dd'));
    setMostrarTodasTarefas(Boolean(eventoInicial));
    setMostrarConcluidas(false);
    setLinhaTexto('');
    setEventosDaPlaca([]);
    const eventosCarregados = Object.values(eventosBrutos).flat();
    setEventosSnapshot(eventosCarregados);
    setEventoSelecionado(eventoInicial || null);
    setMostrarSeletorData(false);
    setDataVencimentoManual('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aberto]);

  // Mede a largura do texto digitado para posicionar a dica fantasma
  useLayoutEffect(() => {
    if (medidorRef.current) {
      setLarguraTexto(medidorRef.current.offsetWidth);
    }
  }, [linhaTexto]);

  // Foca o campo logo após a placa ao selecionar um evento
  useEffect(() => {
    if (eventoSelecionado && inputRef.current) {
      const posicao = linhaTexto.length;
      inputRef.current.focus();
      inputRef.current.setSelectionRange(posicao, posicao);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventoSelecionado]);
  // --------------------------------

  if (!aberto) return null;

  const fechar = () => {
    setLinhaTexto('');
    if (onFechar) onFechar();
  };
  // --------------------------------

  const filtrarEventosCarregados = (placa) => eventosSnapshot
    .filter((evento) => (evento?.placa || '').toUpperCase().includes(placa));

  const extrairPlaca = (texto) => texto.trim().split(/\s+/)[0] || '';

  const apenasDigitos = (texto) => texto.replace(/\D/g, '');
  // --------------------------------
  const formatarValor = (digitos) => {
    if (!digitos) return '';

    const numero = Number(digitos) / 100;
    const [inteiro, decimais] = numero.toFixed(2).split('.');
    const inteiroFormatado = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `R$${inteiroFormatado},${decimais}`;
  };
  // --------------------------------
  const posicionarCursorNoFinal = (texto) => {
    requestAnimationFrame(() => {
      if (inputRef.current) {
        inputRef.current.setSelectionRange(texto.length, texto.length);
      }
    });
  };

  // --------------------------------
  const alterarLinhaTexto = (valor) => {
    if (eventoInicial) {
      setLinhaTexto(valor);
      return;
    }

    const primeiraPalavra = extrairPlaca(valor).toUpperCase();
    const eventoAindaValido = eventoSelecionado && primeiraPalavra === eventoSelecionado.placa?.toUpperCase();

    if (eventoSelecionado && !eventoAindaValido) {
      // usuário alterou a placa já confirmada, reabre a busca
      setEventoSelecionado(null);
    }

    if (!eventoAindaValido) {
      setLinhaTexto(valor);
      setEventosDaPlaca(primeiraPalavra.length < 3 ? [] : filtrarEventosCarregados(primeiraPalavra));
      return;
    }

    setEventosDaPlaca([]);

    // Aplica máscara de moeda automaticamente enquanto o valor (segundo token) é digitado
    const placaTexto = eventoSelecionado.placa;
    const resto = valor.slice(placaTexto.length);
    const terminaComEspaco = /\s$/.test(resto);
    const tokens = resto.trim().split(/\s+/).filter(Boolean);

    if (tokens.length <= 1) {
      const valorFormatado = formatarValor(apenasDigitos(tokens[0] || ''));
      const espacoFinal = terminaComEspaco && valorFormatado ? ' ' : '';
      const linhaAtualizada = `${placaTexto} ${valorFormatado}${espacoFinal}`;
      setLinhaTexto(linhaAtualizada);
      posicionarCursorNoFinal(linhaAtualizada);
      return;
    }

    const valorFormatado = formatarValor(apenasDigitos(tokens[0]));
    const observacao = tokens.slice(1).join(' ') + (terminaComEspaco ? ' ' : '');
    setLinhaTexto(`${placaTexto} ${valorFormatado} ${observacao}`);
  };
// --------------------------------
  const selecionarEvento = (evento) => {
    setEventoSelecionado(evento);
    setEventosDaPlaca([]);
    setLinhaTexto(`${evento.placa} `);
  };

  const limparLinha = () => {
    setLinhaTexto('');
    setEventosDaPlaca([]);
    setEventoSelecionado(null);
    setMostrarSeletorData(false);
    setDataVencimentoManual('');
  };
  // --------------------------------
  const obterDica = () => {
    if (!eventoSelecionado || eventoInicial) return '';

    const terminaComEspaco = /\s$/.test(linhaTexto);
    const tokensResto = linhaTexto.trim().split(/\s+/).slice(1).filter(Boolean);

    if (tokensResto.length === 0) return 'Digite um valor';
    if (tokensResto.length === 1 && terminaComEspaco) return 'Observação';
    return '';
  };
  // --------------------------------

  const tarefasDoEvento = Array.isArray(eventoSelecionado?.tarefas)
    ? eventoSelecionado.tarefas
    : [];
  // --------------------------------
  const tarefasDoMes = eventosSnapshot
    .filter((eventoDoDia) => !eventoInicial || eventoDoDia._id === eventoInicial._id)
    .concat(eventoSelecionado && !eventosSnapshot.some((evento) => evento._id === eventoSelecionado._id)
      ? [eventoSelecionado]
      : [])
    .flatMap((eventoDoDia) => (Array.isArray(eventoDoDia?.tarefas) ? eventoDoDia.tarefas : [])
      .filter((tarefa) => {
        if (eventoInicial) return true;
        if (!tarefa.dataVencimento) return false;
        if (!tarefa.concluida && tarefa.dataVencimento < hojeFormatado) return true;
        const dataVencimento = new Date(`${tarefa.dataVencimento}T00:00:00`);
        return dataVencimento.getFullYear() === anoNotas && dataVencimento.getMonth() === mesNotas;
      })
      .map((tarefa) => {
        // Tarefa vencida e não concluída aparece automaticamente no dia atual
        const dataEfetiva = !tarefa.concluida && tarefa.dataVencimento < hojeFormatado
          ? hojeFormatado
          : tarefa.dataVencimento;

        return {
          ...tarefa,
          dataVencimento: dataEfetiva,
          eventoId: eventoDoDia._id,
          eventoNome: eventoDoDia.tipoEvento || descricaoParaTexto(eventoDoDia.descricao) || 'Evento sem descrição',
          eventoPlaca: eventoDoDia.placa,
        };
      }))
    .filter((tarefa, indice, lista) => lista.findIndex((item) => (
      item.eventoId === tarefa.eventoId && item.id === tarefa.id
    )) === indice);
  // --------------------------------

  const tarefasExibidas = (mostrarTodasTarefas
    ? tarefasDoMes.filter((tarefa) => eventoInicial || mostrarConcluidas || !tarefa.concluida)
    : tarefasDoMes.filter((tarefa) => tarefa.dataVencimento === diaNotasSelecionado)
  ).sort((tarefaA, tarefaB) => {
    const dataA = tarefaA.dataVencimento || '9999-12-31';
    const dataB = tarefaB.dataVencimento || '9999-12-31';
    return dataA.localeCompare(dataB);
  });
  // --------------------------------

  const datasComTarefa = new Set(tarefasDoMes.map((tarefa) => tarefa.dataVencimento));

  const salvarTarefasDoEvento = async (eventoId, tarefas) => {
    if (!eventoId) return;

    setSalvandoTarefa(true);
    try {
      await SalvarTarefasEvento(eventoId, tarefas);
      setEventosSnapshot((atual) => atual.map((evento) => (
        evento._id === eventoId ? { ...evento, tarefas } : evento
      )));
      setEventoSelecionado((atual) => (atual?._id === eventoId ? { ...atual, tarefas } : atual));
    } catch (erro) {
      alert('Não foi possível salvar a tarefa.');
    } finally {
      setSalvandoTarefa(false);
    }
  };
  // --------------------------------
  const adicionarTarefa = async (evento) => {
    evento.preventDefault();

    if (!eventoSelecionado?._id) return;

    const primeiraPalavra = eventoInicial ? '' : extrairPlaca(linhaTexto);
    const descricao = eventoInicial
      ? linhaTexto.trim()
      : linhaTexto.trim().slice(primeiraPalavra.length).trim();

    if (!descricao) return;

    const dataVencimento = dataVencimentoManual || (mostrarTodasTarefas ? hojeFormatado : diaNotasSelecionado);

    await salvarTarefasDoEvento(eventoSelecionado._id, [
      ...tarefasDoEvento,
      { id: Date.now(), descricao, dataVencimento, concluida: false },
    ]);
    limparLinha();
  };
  // --------------------------------
  const alternarTarefa = (tarefa) => {
    const eventoAlvo = eventosSnapshot.find((evento) => evento._id === tarefa.eventoId)
      || (eventoSelecionado?._id === tarefa.eventoId ? eventoSelecionado : null);

    if (!eventoAlvo) return;

    const tarefasAtualizadas = (Array.isArray(eventoAlvo.tarefas) ? eventoAlvo.tarefas : []).map((item) => (
      item.id === tarefa.id ? { ...item, concluida: !item.concluida } : item
    ));

    salvarTarefasDoEvento(tarefa.eventoId, tarefasAtualizadas);
  };
// ######################################################################
  return (
    <S.Overlay>
      <S.ModalCard onClick={(evento) => evento.stopPropagation()}>
        <S.ModalHeader>
          <span>{eventoInicial ? `Tarefas do evento ${eventoInicial.placa || ''}` : 'Bloco de notas'}</span>
          <button type="button" onClick={fechar} aria-label="Fechar notas"><FiX /></button>
        </S.ModalHeader>

        <S.ModalBody>
          {!eventoInicial && 
          <S.DiasNotas aria-label="Dias do mês">
            {Array.from({ length: quantidadeDiasNotas - diaAtualNumero + 1 }, (_, indice) => {
              const dia = diaAtualNumero + indice;
              const dataDia = format(new Date(anoNotas, mesNotas, dia), 'yyyy-MM-dd');

              return (
                <S.DiaNota
                  key={dataDia}
                  type="button"
                  selecionado={!mostrarTodasTarefas && dataDia === diaNotasSelecionado}
                  onClick={() => {
                    setMostrarTodasTarefas(false);
                    setDiaNotasSelecionado(dataDia);
                  }}
                  aria-label={`Ver tarefas do dia ${dia}`}
                >
                  {dia}
                  {datasComTarefa.has(dataDia) && <S.IndicadorTarefa aria-hidden="true" />}
                </S.DiaNota>
              );
            })}
            <S.BotaoTodasTarefas
              type="button"
              selecionado={mostrarTodasTarefas}
              onClick={() => setMostrarTodasTarefas(true)}
              aria-label="Mostrar todas as tarefas do mês"
              title="Todas as tarefas do mês"
            >
              <FiList size={16} />
            </S.BotaoTodasTarefas>
          </S.DiasNotas>
          }

          {/* -------------------------------- */}
          <S.TarefasDia>
            <S.AvisoNotas>
              {eventoInicial ? 'Todas as tarefas deste evento' : mostrarTodasTarefas ? 'Todas as tarefas do mês' : 
              `Tarefas do dia ${format(new Date(`${diaNotasSelecionado}T00:00:00`), 'dd/MM/yyyy')}`
              }

              {mostrarTodasTarefas && !eventoInicial && (
                <S.BotaoConcluidas
                  type="button"
                  selecionado={mostrarConcluidas}
                  onClick={() => setMostrarConcluidas((valor) => !valor)}
                  aria-label={mostrarConcluidas ? 'Ocultar tarefas concluídas' : 'Mostrar tarefas concluídas'}
                  title={mostrarConcluidas ? 'Ocultar tarefas concluídas' : 'Mostrar tarefas concluídas'}
                >
                  <FiCheckCircle size={16} />
                </S.BotaoConcluidas>
              )}
            </S.AvisoNotas>

            {/* -------------------------------- */}
            <S.ListaTarefas>
              {tarefasExibidas.map((tarefa) => (
                <S.Tarefa key={`${tarefa.eventoId}-${tarefa.id}`} concluida={tarefa.concluida}>
                  <input
                    type="checkbox"
                    checked={tarefa.concluida}
                    onChange={() => alternarTarefa(tarefa)}
                  />
                  {mostrarTodasTarefas && (
                  <span>
                    {tarefa.dataVencimento ? format(new Date(tarefa.dataVencimento + 'T00:00:00'), 'dd/MM') : ''} 
                  </span>
                  )}
                  <small>{tarefa.eventoPlaca}</small>
                  <span>
                    {String(tarefa.descricao || '').replace(/^R\$(?!\s)/, 'R$ ')}
                  </span>
                  
                </S.Tarefa>
              ))}

              {tarefasExibidas.length === 0 && (
                <S.CardMeta>
                  {mostrarTodasTarefas ? 'Nenhuma tarefa para este mês.' : 'Nenhuma tarefa para este dia.'}
                </S.CardMeta>
              )}
            </S.ListaTarefas>
          </S.TarefasDia>

          {/* linha digitação da nova tarefa */}
          <S.LinhaTarefa onSubmit={adicionarTarefa}>
            <S.CampoComDica>
              <input
                ref={inputRef}
                type="text"
                placeholder={eventoInicial ? 'Digite a descrição...' : 'Digite a placa...'}
                value={linhaTexto}
                onChange={(evento) => alterarLinhaTexto(evento.target.value)}
                aria-label="Placa, valor e observação da tarefa"
              />
              <S.TextoMedidor ref={medidorRef}>{linhaTexto}</S.TextoMedidor>
              {obterDica() && (
                <S.TextoFantasma style={{ left: `${larguraTexto + 10}px` }}>
                  {obterDica()}
                </S.TextoFantasma>
              )}
            </S.CampoComDica>

            {/* -------------------------------- */}
            <S.BotaoIconeData
              type="button"
              ativo={mostrarSeletorData}
              onClick={() => setMostrarSeletorData((valor) => !valor)}
              aria-label="Alterar data da tarefa"
              title="Alterar data da tarefa"
            >
              <FiCalendar size={16} />
            </S.BotaoIconeData>

            {mostrarSeletorData && (
              <input
                type="date"
                value={dataVencimentoManual || (mostrarTodasTarefas ? hojeFormatado : diaNotasSelecionado)}
                onChange={(evento) => setDataVencimentoManual(evento.target.value)}
                aria-label="Data de vencimento da tarefa"
              />
            )}

            <button
              type="submit"
              disabled={!eventoSelecionado || !(eventoInicial ? linhaTexto.trim() : linhaTexto.trim().slice(extrairPlaca(linhaTexto).length).trim())}
            >
              Concluído
            </button>
          </S.LinhaTarefa>
          {/* -------------------------------- */}

          {eventosDaPlaca.length > 0 && !eventoSelecionado && (
            <S.ListaEventos>
              <S.AvisoNotas>Selecione o evento que receberá a tarefa:</S.AvisoNotas>
              {eventosDaPlaca.map((evento) => (
                <S.EventoSelecionavel key={evento._id} type="button" onClick={() => selecionarEvento(evento)}>
                  <strong>{evento.tipoEvento || descricaoParaTexto(evento.descricao) || 'Evento sem descrição'}</strong>
                  <small>{evento.dataEvento ? format(new Date(evento.dataEvento), 'dd/MM/yyyy') : 'Data não informada'} - {evento.placa}</small>
                </S.EventoSelecionavel>
              ))}
            </S.ListaEventos>
          )}
          {/* -------------------------------- */}

          {extrairPlaca(linhaTexto).length >= 3 && !eventoSelecionado && eventosDaPlaca.length === 0 && (
            <S.AvisoNotas>Nenhum evento encontrado para esta placa.</S.AvisoNotas>
          )}

          {salvandoTarefa && <S.AvisoNotas>Salvando...</S.AvisoNotas>}
        </S.ModalBody>

        <S.ModalFooter>
          <button type="button" onClick={fechar}>Fechar</button>
        </S.ModalFooter>
      </S.ModalCard>
    </S.Overlay>
  );
}
